export const siteInfo = {
  name: '真相回旋镖',
  slogan: '看清黑料背后的真实走向',
  intro:
    '真相回旋镖是一个聚焦网络爆料反转与辟谣澄清的观察站。我们把一条爆料从出现、发酵到澄清、反转的全过程整理成可追溯的时间线，标注信息来源与核实状态，让读者在情绪之外看到事实。',
  email: 'hello@truth-boomerang.example',
  notice: '本站内容为情景化示例整理，涉及人物均做匿名处理，请以官方通报与可核实信息为准。',
};

export const siteStats = [
  { value: '1,280', label: '累计收录案例', hint: '含澄清与反转' },
  { value: '863', label: '已完成核实', hint: '标注信息来源' },
  { value: '417', label: '剧情发生反转', hint: '先前的爆料被改写' },
  { value: '24h', label: '热点跟进时效', hint: '重大事件持续追踪' },
];